import React, { Component } from 'react'
import { connect } from 'react-redux'

// import styles
import './photodocmodal.scss'

// Actions
import {
  uploadMultipleFiles,
  createPhotoDoc,
  uploadImageMarkings,
  getOrderFiles,
  UpdateOrderFileSelection,
  DeleteExifData,
  createFileContainer,
  rotateImages
} from '../../../actions/orders'

// Constants
import {
  // API_BASE,
  FILE_STORAGE
} from '../../../constants'

// import components
import Dropzone from '../../components/Dropzone'
import Gallery from '../../components/Gallery'
import CircleImage from '../../components/CircleImage'
import Modal from '../../components/Modal'

import Portal from '../../components/Portal'
import Confirm from '../../components/Confirm'

// Elements
import Radio from '../../elements/radio'
import Textarea from '../../elements/textarea'
import Check from '../../elements/check'
import RemoveButton from '../../elements/removeButton'

import { ModalIcons } from '../../elements/icons'

// Utils
import { translation } from '../../../utils/helpers'

class PhotoDocModal extends Component {

  constructor (props) {
    super(props)
    this.state = {
      tabView: 'step1',
      confirm: false,
      overflowHidden: false,
      images: [],
      upload: {
        shouldCapture: true,
        errors: []
      },
      activeImage: {},
      Comment: '',
      fileContainerId: null,
      Step: 0,
      isCircleimageOpen: false,
      newOrderModalWidth: 0,
      firstRender: true,
      imageSubmitted: false,
      imageUploadsStarted: 0,
      imageUploadsCompleted: 0,
      selectedImages: {}
    }
    this.onClose = this.onClose.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
    // Image
    this.submitImage = this.submitImage.bind(this)
    this.onDrop = this.onDrop.bind(this)
    this.onDropAccepted = this.onDropAccepted.bind(this)
    this.onDropRejected = this.onDropRejected.bind(this)
    this.uploadImages = this.uploadImages.bind(this)
    this.onCircleImageClose = this.onCircleImageClose.bind(this)
    this.checkboxChange = this.checkboxChange.bind(this)
    this.t = this.t.bind(this)
  }

  componentDidUpdate () {
    if (this.state.firstRender) {
      let newOrderModalWidth
      if (document.getElementsByClassName('modal__container')[0] !== undefined) {
        newOrderModalWidth = document.getElementsByClassName('modal__container')[0].getBoundingClientRect().width
      }
      this.setState({
        newOrderModalWidth: newOrderModalWidth,
        firstRender: false
      })
    }
  }

  componentDidMount () {
    let images = []
    this.props.getOrderFiles(this.props.item.Id, 1).then((res) => {
      res.data.forEach(function (element) {
        images.push({
          imagePath: FILE_STORAGE + element.FileURL,
          thumbPath: FILE_STORAGE + element.ThumbURL,
          OrderFileID: element.OrderFileID
        })
      }, this)
      this.setState({
        images: images
      })
    })

    this.setState({
      Step: this.props.stepId || this.props.item.StepId
    })

    this.props.createFileContainer().then((res) => {
      this.setState({
        fileContainerId: res.data.FileContainerId
      })
    })
  }

  t (val) {
    if (typeof translation !== 'undefined') {
      return translation(val)
    }
    return this.props.t(val)
  }

  onInputChange (e) {
    let value = e.target.value
    if (e.target.name === 'Step') {
      value = parseInt(value)
    }
    this.setState({
      [e.target.name]: value
    })
  }

  onClose () {
    if (this.state.tabView === 'step2') {
      this.setState({
        tabView: 'step1'
      })
    } else {
      this.props.onClose()
    }
  }

  checkboxChange (e) {
    // let input
    // if (e.target.tagName === 'DIV') {
    //   // if div click
    //   input = e.target.children[0]
    //   input.checked = !input.checked
    //   console.log('checkboxChange DIV')
    // } else if (e.target.tagName === 'B') {
    //   // if b click
    //   input = e.target.parentElement.children[0]
    //   input.checked = !input.checked
    //   console.log('checkboxChange B')
    // } else if (e.target.tagName === 'INPUT') {
    //   // if input click
    //   input = e.target
    //   input.checked = !input.checked
    //   console.log('checkboxChange INPUT')
    // }
    this.setState({ selectedImages: {...this.state.selectedImages, [e.target.id]: e.target.checked} })
  }

  renderImages () {
    let { images } = this.state
    // Render image
    const renderImage = (image, index) => {
      if (image.imageUrl !== undefined) {
        return (
          <div key={index}>
            <div className='divImg'>
              <div className='delete'><RemoveButton {...this.props} onClick={() => this.deleteImage(image, index)} size='s' /></div>
              <img className='img2' id={image.OrderFileID} src={image.base64} onClick={() => this.goToImage(image, index)} />
            </div>
            <div className='divCheckbox'>
              <Check spacing={0} labelText={this.t('1218')} id={image.OrderFileID} name='checkbox_image' checked disabled />
            </div>
          </div>
        )
      } else {
        return (
          <div key={index}>
            <div className='divImg'>
              <a href={image.imagePath} data-lightbox='gallery'>
                <img className='img3' id={image.OrderFileID} name='oldImages' src={image.thumbPath} />
              </a>
            </div>
            <div className='divCheckbox' >
              <Check spacing={0} labelText={this.t('1218')} id={image.OrderFileID} name='checkbox_image' checked={this.state.selectedImages[image.OrderFileID] === true} onChange={this.checkboxChange} />
            </div>
          </div>
        )
      }
    }
    // Confirm
    const onPortalClose = () => {
      this.setState({
        confirm: false
      })
    }
    const onConfirm = () => {
      let images = [...this.state.images]
      images.splice(this.state.confirm, 1)
      this.setState({
        confirm: false,
        images: images
      })
    }
    // Return
    return (
      <div>
        <Gallery files={images} renderImage={renderImage} />
        {this.state.confirm !== false && (
          <Portal className='deleteModal' t={this.props.t} onPortalClose={onPortalClose}>
            <Confirm confirm={onConfirm} notConfirm={onPortalClose} />
          </Portal>
        )}
      </div>
    )
  }

  onDrop () {
    this.setState({ upload: { ...this.state.upload, errors: [] } })
  }

  onDropAccepted (files) {
    this.setState({ imageUploadsStarted: this.state.imageUploadsStarted + files.length })
    this.props.uploadMultipleFiles(files, 0, undefined, undefined, this.state.fileContainerId).then((fileResponse) => {
      let newImages = [ ...this.state.images ]
      const uploadedFiles = fileResponse.data
      uploadedFiles.map((val, index) => {
        if (val.IsImage) {
          newImages.push({
            imageUrl: FILE_STORAGE + val.FileURL,
            ImageSize: {
              Width: 0,
              Height: 0
            },
            OrderFileID: val.OrderFileID,
            circles: [],
            ImageType: 2,
            base64: files[index].imageUrl,
            rotation: 0
          })
        }
      })
      newImages.map((val) => {
        if (typeof val.ImageSize === 'undefined') {
          val.ImageSize = {
            Width: 0,
            Height: 0
          }
        }
      })
      this.setState({ images: newImages, imageUploadsCompleted: this.state.imageUploadsCompleted + files.length })
    }).catch(() => {
      this.setState({ imageUploadsCompleted: this.state.imageUploadsCompleted + files.length })
    })
  }

  onDropRejected (files) {
    let newErrors = []
    files.map((val, index) => {
      newErrors.push(this.t('1207') + ': ' + val.name + ' ' + this.t('13405') + '.')
    })
    this.setState({ upload: { ...this.state.upload, errors: newErrors } })
  }

  goToImage (image, index) {
    this.setState({
      tabView: 'step2',
      isCircleimageOpen: true,
      activeImage: {
        image: image,
        index: index
      }
    })
  }

  submitImage (image) {
    let images = [...this.state.images]
    images[image.index] = image.image
    this.setState({
      tabView: 'step1',
      images: images,
      isCircleimageOpen: false,
      imageSubmitted: true
    })
  }

  onCircleImageClose (image) {
    if (!this.state.imageSubmitted) {
      let images = [...this.state.images]
      images[image.index] = image.image
      this.setState({
        tabView: 'step1',
        images: images,
        isCircleimageOpen: false
      })
    } else {
      this.setState({
        imageSubmitted: false
      })
    }
  }

  deleteImage (image, index) {
    this.setState({
      confirm: index
    })
  }

  uploadImages (e) {
    e.preventDefault()
    if (this.state.imageUploadsStarted !== this.state.imageUploadsCompleted) {
      return window.toastr.error(this.t('15335'), this.t('216'))
    }
    const checkErrors = () => {
      let inp = document.getElementsByTagName('input')
      for (let i = 0; i < inp.length; i++) {
        if (inp[i].name === 'checkbox_image' && inp[i].checked === true) {
          return false
        }
      }
      return true
    }

    let error = checkErrors()
    if (error) return window.toastr.error(this.t('2031'), this.t('216'))

    let finishedFiles = []
    let orderFileIds = []
    let imageMarkings = []
    const uploadedFiles = this.state.images

    uploadedFiles.map((val, index) => {
      let markings = []
      if (this.state.images[index].circles !== undefined) {
        this.state.images[index].circles.map((circle, circleIdx) => {
          markings.push({
            PositionX: circle.left,
            PositionY: circle.top,
            Scale: parseFloat(circle.scale.toFixed(2)),
            Size: 50
          })
        })
      }
      if (markings.length !== 0 || (val.rotation !== 0 && val.rotation !== undefined)) {
        imageMarkings.push({
          ImageSize: this.state.images[index].ImageSize,
          OrderFileID: val.OrderFileID,
          Markings: markings,
          Rotation: val.rotation
        })
      }
    })
    let inputs = document.getElementsByClassName('gallery')[0].getElementsByTagName('input')
    for (let i = 0; i < inputs.length; i++) {
      if (inputs[i].name === 'checkbox_image' && inputs[i].checked === true) {
        finishedFiles.push({
          OrderFileId: inputs[i].id
        })
        orderFileIds.push(inputs[i].id)
      }
    }
    // imageMarkings[0].ImageSize.Width = 1000
    // imageMarkings[0].ImageSize.Height = 500

    this.props.createPhotoDoc({
      FileContainerId: this.state.fileContainerId,
      OrderId: this.props.item.Id,
      Images: finishedFiles,
      Step: this.state.Step,
      OrderNote: {
        OrderNoteId: 0,
        Note: this.state.Comment
      }
    }).then((res) => {
      if (imageMarkings.length !== 0) {
        this.props.uploadImageMarkings(imageMarkings)
      }
      this.props.UpdateOrderFileSelection({
        OrderFileIds: orderFileIds,
        Type: 1,
        Step: this.state.Step,
        TypeId: res.data.OrderNote.OrderNoteId,
        QualityCheckPhotoStart: this.props.QualityCheckPhotoStart === true,
        QualityCheckPhotoEnd: this.props.QualityCheckPhotoEnd === true
      }).then((res) => {
        if (this.props.setImages !== undefined) {
          this.props.setImages()
        }
      }, () => window.toastr.error(this.t('960'), this.t('216')))
      this.props.onClose()
      // window.toastr.success(this.t('2032'), this.t('13424'))
    }, () => window.toastr.error(this.t('960'), this.t('216')))
  }

  renderStep1 () {
    let { errors } = this.state.upload
    let disabledSteps = this.props.QualityCheckPhotoStart === true || this.props.QualityCheckPhotoEnd === true
    const renderError = (error, index) => {
      return <p key={index}>{error}</p>
    }
    const createStep = (key, name) => {
      return {
        key: key,
        name: name
      }
    }
    // Render order steps
    let orderStepIds = [1, 101, 102, 105, 2, 3, 4, 5, 6, 103, 104, 7]
    let shopOrderSteps = []
    orderStepIds.map(stepId => {
      switch (stepId) {
        case 1:
          shopOrderSteps.push(createStep(stepId, 164))
          break
        case 101:
          if (this.props.auth.departmentType === 1 || this.props.auth.departmentType === 2) shopOrderSteps.push(createStep(stepId, 617))
          break
        case 102:
          if (this.props.auth.departmentType === 1 || this.props.auth.departmentType === 2) shopOrderSteps.push(createStep(stepId, 618))
          break
        case 105:
          if (this.props.auth.departmentType === 1) shopOrderSteps.push(createStep(stepId, 161))
          break
        case 2:
          if (this.props.auth.departmentType === 0 || this.props.auth.departmentType === 2) shopOrderSteps.push(createStep(stepId, 96))
          break
        case 3:
          if (this.props.auth.departmentType === 0 || this.props.auth.departmentType === 2) shopOrderSteps.push(createStep(stepId, 160))
          break
        case 4:
          if (this.props.auth.departmentType === 0 || this.props.auth.departmentType === 2) shopOrderSteps.push(createStep(stepId, 158))
          break
        case 5:
          if (this.props.auth.departmentType === 0 || this.props.auth.departmentType === 2) shopOrderSteps.push(createStep(stepId, 161))
          break
        case 6:
          if (this.props.auth.departmentType === 0 || this.props.auth.departmentType === 2) shopOrderSteps.push(createStep(stepId, 162))
          break
        case 103:
          if (this.props.auth.departmentType === 1 || this.props.auth.departmentType === 2) shopOrderSteps.push(createStep(stepId, 619))
          break
        case 104:
          if (this.props.auth.departmentType === 1 || this.props.auth.departmentType === 2) shopOrderSteps.push(createStep(stepId, 162))
          break
        case 7:
          shopOrderSteps.push(createStep(stepId, 163))
          break
      }
    })
    const renderStep = (stepId, name) => {
      let inputId = 'step-' + stepId
      let value = '' + stepId
      let labelText = name
      return (
        <Radio id={inputId} name='Step' value={value} onChange={this.onInputChange} checked={this.state.Step === stepId} disabled={disabledSteps} labelText={labelText} key={stepId} />
      )
    }
    return (
      <div>
        {shopOrderSteps.map(step => renderStep(step.key, this.t(step.name)))}
        {errors.length !== 0 && <div className='alert alert-danger'>{errors.map(renderError)}</div>}
        <Dropzone
          onDrop={this.onDrop}
          onDropAccepted={this.onDropAccepted}
          onDropRejected={this.onDropRejected}
          includeCircles>
          <p>{this.t('13397')}</p>
        </Dropzone>
        {this.renderImages()}
        <Textarea name='Comment' onChange={this.onInputChange} value={this.state.Comment} labelText={this.t('149')} />
      </div>
    )
  }

  renderStep2 () {
    const circleDrag = (active) => {
      this.setState({ overflowHidden: active })
    }

    return (
      <CircleImage
        submitImage={this.submitImage}
        image={this.state.activeImage}
        onDrag={circleDrag}
        onCircleImageClose={this.onCircleImageClose}
        newOrderModalWidth={this.state.newOrderModalWidth}
        t={this.t} />
    )
  }

  render () {
    let modalClass = 'photodoc__modal'
    let tabView = <div />
    let bottomBarProps = null
    if (this.state.tabView === 'step1') {
      tabView = this.renderStep1()
      bottomBarProps = {
        actionLabelText: this.t('791'),
        onActionClick: this.uploadImages,
        disabled: this.props.uploads.inProgress
      }
    } else if (this.state.tabView === 'step2') {
      tabView = this.renderStep2()
    }

    let titleText = this.t('2065')
    if (this.state.isCircleimageOpen) {
      modalClass = 'circleimage_modal'
      titleText = this.t('15051')
    }

    let clickOutsideClose = false
    return (
      <div className={modalClass}>
        <Modal {...this.props}
          isLoading={this.props.uploads.inProgress}
          icon={ModalIcons.Camera}
          header={titleText}
          overflowHidden={this.state.overflowHidden}
          clickOutsideClose={clickOutsideClose}
          onClose={this.onClose}
          bottomBarProps={bottomBarProps}
        >
          {tabView}
          <div style={{clear: 'both'}} />
        </Modal>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    paintShopOrderSteps: state.common.enums_new.PaintShopOrderSteps,
    auth: state.auth,
    uploads: state.uploads
  }
}

export default connect(mapStateToProps, {
  uploadMultipleFiles,
  createPhotoDoc,
  uploadImageMarkings,
  getOrderFiles,
  UpdateOrderFileSelection,
  DeleteExifData,
  createFileContainer,
  rotateImages
})(PhotoDocModal)



// WEBPACK FOOTER //
// ./src/app/shared/modals/PhotoDocModal/index.js